
import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild,ChangeDetectorRef, TemplateRef, ViewContainerRef, ChangeDetectionStrategy, AfterViewInit, AfterViewChecked  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT, NgFor, NgForOf, NgTemplateOutlet } from '@angular/common';

import { Observable } from 'rxjs/internal/Observable';

// models ==========================================================================
import { MainModel } from '../../model/MainModel';
import { SearchModel, DisplayColumn, LookupItem, LookupFilter, FilterModel, getBlankFilter } from '../../model/SearchModel';
import PagingModel from '../../model/PagingMoel';

// SERVICES  =======================================================================
import { SearchService } from '../../services/data/search-service/searchservice';
import { ServerClientService } from '../../services/data/campaign-service/server-client.service';
import { UserPermissionsService } from '../../services/permissions/UserPermissionsService';

// prime ng components ---------------------------------------------------------------
import { Table, TableModule, TablePageEvent, TableService } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { MenuModule } from 'primeng/menu';
import { CardModule } from 'primeng/card';
import { ToastModule } from 'primeng/toast';
import { MultiSelectModule } from 'primeng/multiselect';
import { MenuItem, MessageService, SelectItem } from 'primeng/api';
import { TagModule } from 'primeng/tag';
import { InputIconModule } from 'primeng/inputicon';
import { InputGroupModule } from 'primeng/inputgroup';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { IconFieldModule } from 'primeng/iconfield';
import { DropdownModule } from 'primeng/dropdown';
import { SplitButtonModule } from 'primeng/splitbutton';
import { InputTextModule } from 'primeng/inputtext';

// Random -----------------------------------------------------------------------------
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

// OUR COMPONENTS -------------------------------
import { ExportColumn, TableDataType } from '../../model/ExportColumn';
import { GenericButtonComponent } from "../../../global/component/generic/generic-button/generic-button.component";
import { GenericTextInputComponent } from "../../../global/component/generic/generic-text-input/generic-text-input.component";
import { LoadingSpinnerComponent } from "../loading-spinner/loading-spinner.component";
import { MatchType } from '../../model/search/MatchType';
import { filter } from 'lodash';
import { CheckboxModule } from 'primeng/checkbox';
import { ListboxClickEvent, ListboxModule } from 'primeng/listbox';
import { TextInputComponent } from '../text-input/text-input.component';
import { DialogModule } from 'primeng/dialog';
import { EventModalComponent } from "../../../vortex/shared-components/event-modal/event-modal.component";
import { EventModel } from '../../../vortex/models/EventModel';
import { EventService } from '../../../vortex/services/event.service';
import { CalendarModule } from 'primeng/calendar';
import { TableFilterComponent } from "../generic/table-filter/table-filter.component";
import { exportToExcel, generateVisibleColumns, harvestFilters, outputProperDisplayFormat } from '../../util/util';
import { switchMap } from 'rxjs';



@Component({
  selector: 'rc-search-core',
  standalone: true,
  imports: [TableModule, SplitButtonModule, InputTextModule, CheckboxModule, CalendarModule,
    DropdownModule, CommonModule, NgFor, NgForOf, DialogModule,
    ButtonModule, FormsModule, MultiSelectModule, ToggleButtonModule, MenuModule, GenericButtonComponent,
    ToastModule, TagModule, InputGroupModule, InputIconModule, IconFieldModule, CardModule, ListboxModule,
    DialogModule, GenericTextInputComponent, LoadingSpinnerComponent, EventModalComponent, TableFilterComponent],
  providers: [MessageService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './search-core.component.html',
  styleUrl: './search-core.component.scss'
})
export class SearchCoreComponent implements OnInit, AfterViewInit, AfterViewChecked { // AfterViewInit  

  onloadDataSet:any|null = null; // data set from the page load...
  lastSearch:any = undefined; // filters from last search..

  // Local state ----------------------------------------------------
  isExpandedView = false;
  showLoading: boolean = false;
  maxSelected:number = 20 ;
  searchPerformed:boolean = false;
  get hasResults(){ return this.data?.length > 0 };
  get hasFilters(){ return this.selectedColumns.filter( item => item.filterModel.from.length > 0 ).length > 0 };
  allItemsChecked:boolean = false;

  // modal =========================================================
  confirmAction:string|null = null;
  showConfirmModal:boolean = false;
  lastClicked:any = null;

  // MODELS ========================================================
  pagingModel: PagingModel = new PagingModel();
  columnData: SearchModel = {
    displayColumns: [],
    states: [],
    fundCodes: [],
    commonFilters: [],
    textFilters: [],
    rangeFilters: [],
    amountFilters: [],
    statusOptions: [],
    approvalOptions: [],
    fundraisers: [],
    sources: [],
    events: [],
    checkbooks: [],
    dateFilters: [],
    batchTypes: []
  };

  @Input({ required: !true }) isSearchOnLoad: boolean = true;
  @Input({ required: !true }) dataType: TableDataType = TableDataType.Events;
  @Input({ required: true }) exportLabel:string|null = null; // if this component goes global the type can define the export label
  
  // OUTPUTS ========================================================
  @Output() dataViewUpdate = new EventEmitter<PagingModel>();

  // data from the back end...
  data: DisplayColumn[]               = [];

  // columns --------------------------------------------------------
  defaultColumns: DisplayColumn[]     = [];  // the default displayed columns for this search...
  selectedColumns: DisplayColumn[]    = [];  // the selected displayed columns for this search...
  checkedColumns: DisplayColumn[]    = [];  // the selected displayed columns for this search...
  get resultsColspan(){ return this.selectedColumns.length + 2};
  balanceFrozen: boolean              = true;
  
  // filters composed on the server side ----------------------------
  filterString:string                 = ""; // built from filters...
  filterModel:any                     = {}; // contains values
  groupedDisplayColumns:Array<any>    = [];

  addEventModel:EventModel            = new EventModel();
  showAddEventModal:boolean           = false;
  eventTypes:Array<any>               = [];
  
  // filter data structures composed on the client side ----------------------------
  selectedOptions: MenuItem[]         = [];
  numberOfItemsSelected:number = 0;
  

  // BEHAVIOR CHANGING INPUTS =======================================
  @Input() public validateSubmit: boolean = true;
  @Input() showInDialog: boolean = false;

  // TEMPLATES ========================================================
  @Input() public tableBodyTemplate!: TemplateRef<any>;
  @Input() public topButtonTemplate!: TemplateRef<any>; // this isnt currently used all the table headers are the same but here for future possible use...
  @Input() public tableHeadersTemplate!: TemplateRef<any>; // this isnt currently used all the table headers are the same but here for future possible use...

  // VIEW CHILD ========================================================
  @ViewChild('container', { read: ViewContainerRef }) container!: ViewContainerRef;
  @ViewChild('resultstable') public resultstable!: Table;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    protected servicesearch: SearchService,
    private eventsService:EventService,
    protected messageService: MessageService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    protected serverClient: ServerClientService,
    protected model: MainModel, 
    private activeRoute: ActivatedRoute,
    protected permissions:UserPermissionsService,
    private cd: ChangeDetectorRef
  ) {
    if(this.dataType === undefined){
      this.dataType = TableDataType.Events;
    }
  }

  ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  reorderColumns(event:any){
      if(event.itemValue.value?.columnName?.toLowerCase() === "eventid"){
        const existing = this.selectedColumns.filter(
          _itm => _itm.columnName?.toLowerCase() !== "eventid"
        )
        this.selectedColumns = [event.itemValue.value, ...existing];
        this.cd.detectChanges()
      }
  }

  // LIFE CYCLE METHODS TO OVERRIDE ==================================================================================
  
  /***
   * Overriding classes can use this hook as well - just make sure to call super.ngOnInit() first.
   */
  ngOnInit() {
    this.selectedOptions = [
      { label: 'Activate', icon: 'fa-sharp fa-light fa-thumbs-up', command: () => {
        this.lastClicked = null;
        if(this.howManyChecked() > 0){
          this.openActionDialog(null, 'Activate');
        }
      } },
      { label: 'Inactivate', icon: 'fa-sharp fa-light fa-thumbs-down', command: () => {
        this.lastClicked = null;
        if(this.howManyChecked() > 0){
          this.openActionDialog(null, 'InActivate');
        }
      } },
      { label: 'Delete', icon: 'fa-sharp fa-light fa-trash-can', command: () => {
        this.lastClicked = null;
        if(this.howManyChecked() > 0){
          this.openActionDialog(null, 'Delete');
        }
      } }
    ];
  
    const customFilterName = '_equals';
    this.initializeColumns();
  }
  
  
  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  ngOnChanges() {
    this.cdr.detectChanges();
  }

  updateUI(value:boolean){
    this.showAddEventModal = value;
  }

  // ngAfterViewInit() {
  //   this.container.createEmbeddedView(this.tableBodyTemplate);
  // }

  groupColumnsBy(groupByField: keyof DisplayColumn) {
    const groups: any = {};
    this.columnData.displayColumns.forEach(column => {
      const group = column[groupByField] as string;
      if (!groups[group]) {
        groups[group] = [];
      }
      groups[group].push(column); // Pass entire DisplayColumn object as value
    });

    this.groupedDisplayColumns = Object.keys(groups).map(group => ({
      label: group,
      value: group,
      items: groups[group].map((i:any) => {
        const x:any = {};
        x.label = i.displayColumn;
        x.value = i;
        return x;
      }
    )
    }));
  }

  /**
   * 
   * @param obj 
   */
  getBlankFilter(obj:any):FilterModel{
    return getBlankFilter(obj);
  }

  getDisplayValue(item:any, col:DisplayColumn){
    try {
      if(col.columnName === "IsActive" || col.columnName === "Status"){
        const ref = item["IsActive"];
        return ref.toLowerCase() === "true" ? "Active" : "Inactive";
      } else {
        return outputProperDisplayFormat(item[col.columnName]);
      }
    } catch(err){
      return item[col.columnName];
    }
  }

  /**
   * Gets the generalized data structures that defines table columns, column types, etc... from the back end. 
   * Also sets the values into the local model for displaying filters. 
   * @returns 
   */
  initializeColumns() {
    if(this.dataType === TableDataType.TBD){
      console.debug("TABLE TYPE NEEDS TO BE SET IN ORDER TO SET AND SEARCH DATA IN THSI TABLE.....");
      return;
    }
    const id = this.model?.selectedCampaign()?.campaignId;
    if(id){
      // donation search...
      this.serverClient.getDataTableData(this.dataType || TableDataType.Events, this.pagingModel, id).subscribe(
        (data: SearchModel) => {
          this.columnData = data;
          // build model buckets for the range filters...
          this.columnData.displayColumns.forEach((i:DisplayColumn) => {
            i.filterModel = this.getBlankFilter(i);
            if(i.isDefault){
              this.defaultColumns.push(i);
              this.selectedColumns.push(i);
            }
          });
          // ----------------------------------------------------------------
          this.filterModel = {};
          this.groupColumnsBy('groupByColumn');
          this.generateEventTypes();
          
          if(this.isSearchOnLoad === true && this.onloadDataSet === null){
            const result = this.search(this.buildFilterData());
            if(result !== null){
            setTimeout(
                () => {
                  this.onloadDataSet = this.data;
                }, 5000
              )
            } 
          }
          
        }
      );

    } else {
      // temporary fix for always using code 215 when no code exists yet (e.g. page refresh)  
      setTimeout(() => this.initializeColumns(), 500);
    }
  }


  generateEventTypes():void{
    const evenTyp:DisplayColumn = this.columnData.displayColumns.filter((i:DisplayColumn) => i.columnName === "EventTypeDescription")[0];
    this.eventTypes = (evenTyp?.filterModel?.options || []).map(
      (item:any) => {
        return  { label: item.text, value: item.value }
      }
    );
  }


  /**
   Click handler that trigger a search if all the requirements are optinal to be able to search:
    1. at least one filter has a value to search against
    2. (Not done yet) all filters are validated.
   */ 
  onSearch() {  
    const filterData:Array<any> = this.buildFilterData();
    this.showLoading = true;
    this.data = [];
    this.search(filterData);
  }



  /**
   * Loads data using a similar process for all "current" searches but can be overridden if you need to 
   * call different endpoints, etc...
   */
  search(filterData:Array<MatchType> = this.lastSearch):any {
    const _filters:string = JSON.stringify(filterData);
    this.showLoading = true;
    this.searchPerformed = true;
    this.showAddEventModal = false;
    this.cd.detectChanges();
    if(this.model.selectedCampaign()?.campaignId){
      this.lastSearch = filterData;
      return this.servicesearch.search(this.dataType, _filters).subscribe({
        next: (data: any[]) => {
          this.searchPerformed = true;
          this.showLoading = false;
          this.data = data;
          setTimeout(() => {
            this.cd.detectChanges();
          }, 1000);
        },
        error: (error) => {
          this.showLoading = false;
          this.searchPerformed = true;
          console.error("API Error:", error);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'An error occurred while searching data.',
            life: 7500
          });
        }
      });
    }
    return null;
  }
  


  /**
   * Using a function for this in case we need to do any standardized name formatting.
   * @param val 
   * @returns 
   */
  fieldName(val:string){
    return val;
  }


  /***
   * OVERRIDE THIS FUNCTION.
   * This should set filtering custom to the implementation.(?)
   */
  buildFilterData(): Array<MatchType> {
    return harvestFilters(this.selectedColumns, this.model.selectedCampaign()?.campaignId || 0);
  }

  // Add event stuff =================================================================================================================
  
  initEventModel(){
    this.addEventModel = new EventModel();
    this.showAddEventModal = true;
  }

  addEvent(){
    const id:number = this.model.selectedCampaign()?.campaignId || -1;
    if(id !== -1){
      this.eventsService.createEvent(this.addEventModel, id).subscribe(
        (data:any) => { 
          console.debug(data);
          this.showAddEventModal = false;
          this.search();
        }
      );
    }
  }


  // END LIFECYCLE METHODS ===========================================================================================================
  
  
  closeActionDialog(){
    this.confirmAction = null;
    this.showConfirmModal = false;
  }

  
  
  openActionDialog(item:any, action:string){
    this.confirmAction = action;
    this.lastClicked = item;
    this.showConfirmModal = true;
  }

  doSelectedAction(){
  }

  toggleMenu(col:DisplayColumn){
    col.filterModel.isMenuOpen = !col.filterModel.isMenuOpen;
  }

  resetFilters() {
    this.selectedColumns.forEach(i => {
      if(i.filterModel.options?.length || 
        (i.displayColumnType.columnType === "AmountFilter" || i.displayColumnType.columnType === "DateFilter")){
        i.filterModel.from = "";
        i.filterModel.to = "";
        i.filterModel.op = "equals";
      } else {
        i.filterModel.from = "";
        i.filterModel.to = "";
        i.filterModel.op = "contains";
       }
     });
     this.data = new Array<DisplayColumn>();
     if(this.isSearchOnLoad && this.onloadDataSet !== null){
      this.showLoading = true;
      setTimeout(() => {
        this.data = this.onloadDataSet;
        this.showLoading = false;
      }, 750)
     }
  }


  check(i:DisplayColumn){
    this.howManyChecked();
    if(this.numberOfItemsSelected === this.data.length){
      this.allItemsChecked = true;
    } else {
      this.allItemsChecked = false;
    }
  }

  checkAll(){
    this.data.forEach(
      (i:DisplayColumn) => {
        i.isChecked = this.allItemsChecked;
      }
    );
    if(!this.allItemsChecked){
      this.numberOfItemsSelected = 0;
    } else {
      this.numberOfItemsSelected = this.data.length;
    }
  }
  
  getChecked(){
    this.checkedColumns  = this.data.filter(
      (i:DisplayColumn) => i.isChecked
    );
    return this.checkedColumns;
  }

  howManyChecked(){
    this.numberOfItemsSelected = this.getChecked().length;
    return this.numberOfItemsSelected;
  }

  selectedListString(){
    return this.checkedColumns.map((i:any) => i.EventCode).join(", ");
  }

  performSelectedOperation(){
    const ids:Array<number> = [];
    let action:string|null = null;
    const sendingItems:any = this.getChecked();
    if(this.lastClicked !== null){
      ids.push(this.lastClicked.EventID);
    } else {
      ids.push(...sendingItems.map((i:any) => i.EventID));
    }
    if(this.confirmAction)this.eventsService.batch(this.confirmAction, ids).subscribe(
      (data) => {
        const msg = { severity: 'success', summary: 'The event has been successfully deleted.' };
        if(this.confirmAction === "Delete"){
          msg.summary = "The event has been successfully deleted.";
        }
        if(this.confirmAction === "Update"){
          msg.summary = "You event has been successfully updated.";
        }
        this.messageService.add(msg);
        this.closeActionDialog();
        this.onSearch();
      },
      (error) => {
        console.debug("failure", error);
        this.messageService.add({ severity: 'error', summary: 'There was in issue with updating one or more events' });
        this.closeActionDialog();
      }
    );
  }

  pageForward() {
    (this.document.getElementsByClassName("p-paginator-next")[0] as HTMLAnchorElement).click()
  }

  pageBack() {
    (this.document.getElementsByClassName("p-paginator-prev")[0] as HTMLAnchorElement).click()
  }

  popupMenuClickHandler(col:DisplayColumn, op:any){
    console.debug(1)
    col.filterModel.op = op.value; 
    if(col.filterModel.op !== 'between'){col.filterModel.isMenuOpen = false}
  }

  toggleSelectedLabels() {
    this.isExpandedView = !this.isExpandedView;
    // turn on or off...
  }

  /**
   * 
   * @param start 
   * @param maxResults 
   */
  updatePagingModel(start: number, maxResults: number = 10) {
    this.pagingModel.maxResults = maxResults;
    this.pagingModel.startRow = start;
    this.dataViewUpdate.emit(this.pagingModel);
  }

  pageChange(event: TablePageEvent) {
    this.updatePagingModel(event.first, event.rows);
  }

  convertLookupItemsToSelectItems(lookupItems: LookupFilter[]): SelectItem[] {
    return lookupItems.map((item: LookupFilter) => ({ value: item.value, label: item.label }));
  }
  
  toMultiListOptionItems(collection:any):any[] {
    return collection.map((item: any) => ({ value: item.id, label: item.columnName }));
  }

  getMatchMode(column: any): string {
    if(column.displayColumn){
      const {displayColumnType} = column;
      const {columnType} = displayColumnType;
      if (columnType === "TextFilter" || columnType === "IDFilter" )
        return 'equals';
      if (columnType === "AmountFilter")
        return 'gt';
      else
        return 'startsWith';
    } else {
      return 'equals';
    }
  }
  
  restrictNonNumeric(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault(); // Prevent non-numeric input
    }
  }

  onExportToExcel() { 
    const adjustedValues:Array<any> = this.resultstable.value.map(
      (item:any) => {
        if(typeof(item.IsActive) !== undefined){
          item.Status = item.IsActive?.toLowerCase() === "true" ? "Active" : "Inactive" ;
        }
        return item;
      }
    );
    const _data:any = generateVisibleColumns(this.selectedColumns, adjustedValues, ["EventID"]);
    exportToExcel(_data, this.exportLabel);
  }

  onCancel(): void {
    this.messageService.add({ severity: 'info', summary: 'Cancelled', detail: 'Selection cancelled.' });
  }

}
